import { SaleSummaryContext } from "./sale-summary-context";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SaleSummaryBody from "./sale-summary-body";
import { DateCollection, SaleSummarySchema } from "../../../../helpers/sale-summary-helper";
import { isMobileTabDevice } from "../../../../helpers/device-info-helper";
import { Typography } from "@mui/material";
import { currency } from "../../../../helpers/common-helper";
const currencySymbol = currency();
export function renderAccordionHeader(headerData: any): React.JSX.Element {
  return headerData ? (
    <div className="w-full flex smd:!pr-0 ">
      <Typography
        component={"span"}
        className="flex items-center !m-0 justify-between w-full"
      >
        <div className="flex flex-col w-[100%]">
          <div className="flex !justify-between pr-10">
            <div
              className={`text-[15px] capitalize ${
                headerData?.isSelected ? "font-semibold" : ""
              }`}
            >
              {headerData?.headerName || "Unknown"}
            </div>
            <div className="text-[14px] text-[#3A5E8B]">
              <span>Net Revenue:</span>
              <span className="ml-5 font-semibold">
                {currencySymbol}{Number(headerData?.options?.netSaleAmount).toFixed(2)}
              </span>
            </div>
          </div>
          <div className="flex !justify-between pr-10">
            <div className={`text-[13px] text-[#0000007A]`}>
              <span>{headerData?.options?.saleCount}</span>
              <span className="ml-2">Orders</span>
            </div>
            <div className="text-[13px] text-[#0000007A]">
              <span>Sales Item Revenue:</span>
              <span className="text-[#000000B2] ml-5">
                {currencySymbol}{Number(headerData?.options?.grossSaleAmount).toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </Typography>
    </div>
  ) : (
    <></>
  );
}

export default function SaleSummary({
  summaryDetailsResponse,
  handleSummaryDetails,
  hideFilterMobile,
}: any) {
  const [saleSummaryModal, setSaleSummaryModal] = useState({});
  const [dateArray, setDateArray] = useState(DateCollection);
  const [apiResponse, setApiResponse] = useState(summaryDetailsResponse);
  const [scrollValue, setScrollValue] = useState(0);

  useEffect(() => {
    updateInitialModal(summaryDetailsResponse);
  }, [summaryDetailsResponse]);

  function updateInitialModal(data: any = {}) {
    setSaleSummaryModal(new SaleSummarySchema(data));
  }

  function saleContextValue() {
    return {
      dateArray,
      apiResponse,
      saleSummaryModal,
      scrollValue,
      setScrollValue,
    };
  }

  return (
    <div className="sale-summary-container border border-[#DDDDDD] rounded-[12px] m-20">
      <div className="relative pt-[74px] h-[100%]">
        <div
          className={`sale-summary-header flex items-center py-12 px-16 border-b border-[#DDDDDD]`}
        >
          {isMobileTabDevice() && (
            <div
              className="rista-sprite ic-back-icon cursor-pointer"
              onClick={() => {
                handleSummaryDetails(false);
                hideFilterMobile({});
              }}
            ></div>
          )}
          <div className="flex-1 !text-[17px] font-inter flex font-semibold">
            {summaryDetailsResponse?.branchName}
          </div>
        </div>
        <div className="sale-summary-body">
          <SaleSummaryContext.Provider value={{ ...saleContextValue() }}>
            <SaleSummaryBody />
          </SaleSummaryContext.Provider>
        </div>
      </div>
    </div>
  );
}
